import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth.guard';
import { ClusterTypeComponent } from './cluster-type/cluster-type.component';
import { ClusterComponent } from './cluster/cluster.component';
import { ElasticsearchComponent } from './elasticsearch/elasticsearch.component';
import { SitesComponent } from './sites/sites.component';
import { AiRecommendedParametersComponent } from './ai-recommended-parameters/ai-recommended-parameters.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { UsersComponent } from './users/users.component';
import { ContractsComponent } from './contracts/contracts.component';
import { AddEditContractComponent } from './contracts/add-edit-contract/add-edit-contract.component';
import { TitleResolver } from 'app/resolver/title.resolver';
import { ContractInvoicingReportComponent } from './contracts/contract-invoicing-report/contract-invoicing-report.component';
import { AdminContractService } from '@shared/services/admin-contract.service';
import { JournalAdminClusterComponent } from '../admin-cluster/journal-admin-cluster/journal-admin-cluster.component';
import { AddEditOrganizationComponent } from './organizations/add-organization/add-edit-organization.component';
import { EditUserComponent } from './users/edit-user/edit-user.component';

export const USERS_ROUTE = 'users';
export const ORGANIZATIONS_ROUTE = 'organizations';
export const CONTRACTS_ROUTE = 'contracts';
export const ACTIVITIES = 'activities';
export const SITES_ROUTE = 'sites';
export const CLUSTERS_ROUTE = 'clusters';
export const CLUSTER_TYPE_ROUTE = 'cluster-type';
export const ELASTICSEARCH_ROUTE = 'elasticsearch';
export const IA_RECOMMENDED_PARAMETERS_ROUTE = 'ia-recommended-parameters';

const contractResolver = (route: ActivatedRouteSnapshot, _: RouterStateSnapshot) =>
  inject(AdminContractService).getContract(route.paramMap.get('contractRef'));

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Administration',
      status: false,
    },
    children: [
      {
        path: USERS_ROUTE,
        component: UsersComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'utilisateurs' },
      },
      {
        path: USERS_ROUTE + '/:id',
        component: EditUserComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'utilisateurs' },
      },
      {
        path: ORGANIZATIONS_ROUTE,
        component: OrganizationsComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Organizations' },
      },
      {
        path: ORGANIZATIONS_ROUTE + '/add',
        component: AddEditOrganizationComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Organizations' },
      },
      {
        path: ORGANIZATIONS_ROUTE + '/:organizationCode',
        component: AddEditOrganizationComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Organizations' },
      },
      {
        path: CONTRACTS_ROUTE,
        component: ContractsComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Contracts' },
      },
      {
        path: CONTRACTS_ROUTE + '/add',
        component: AddEditContractComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Contract.add' },
      },
      {
        path: CONTRACTS_ROUTE + '/:contractRef/invoicing-report',
        component: ContractInvoicingReportComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Contract.pageTitle.consumptionReport' },
        resolve: { contract: contractResolver },
      },
      {
        path: CONTRACTS_ROUTE + '/:contractRef',
        component: AddEditContractComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Contract.pageTitle.edit' },
      },
      {
        path: SITES_ROUTE,
        component: SitesComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'site' },
      },
      {
        path: CLUSTERS_ROUTE,
        component: ClusterComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'ClustersShield' },
      },
      {
        path: CLUSTER_TYPE_ROUTE,
        component: ClusterTypeComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'ClusterType' },
      },
      {
        path: ELASTICSEARCH_ROUTE,
        component: ElasticsearchComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Elasticsearchs' },
      },
      {
        path: IA_RECOMMENDED_PARAMETERS_ROUTE,
        component: AiRecommendedParametersComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'RecommendedParameters' },
      },
      {
        path: ACTIVITIES,
        component: JournalAdminClusterComponent,
        canActivate: [AuthGuard],
        title: TitleResolver,
        data: { title: 'Activities' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
